/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Now_BadgeInputs */

const th_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังแข่ง`)
};

const en_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live now`)
};

const ja_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試合中`)
};

const zh_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播中`)
};

const es_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En directo`)
};

const pt_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ao vivo`)
};

const id_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langsung`)
};

const fr_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En direct`)
};

const tl_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const vi_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trực tiếp`)
};

const ko_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실시간`)
};

const de_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const ru_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В эфире`)
};

const tr_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canlı`)
};

const it_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In diretta`)
};

const pl_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na żywo`)
};

const uk_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В ефірі`)
};

const hi_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइव`)
};

const ar_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مباشر`)
};

const ms_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langsung`)
};

const bn_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সরাসরি`)
};

const zh_tw2_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播中`)
};

const zh_hk2_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直播中`)
};

const ur_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`براہ راست`)
};

const fa_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`زنده`)
};

const sw_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moja kwa moja`)
};

const nl_live_now_badge = /** @type {(inputs: Live_Now_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

/**
* | output |
* | --- |
* | "Live now" |
*
* @param {Live_Now_BadgeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const live_now_badge = /** @type {((inputs?: Live_Now_BadgeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Now_BadgeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_live_now_badge(inputs)
	if (locale === "ja") return ja_live_now_badge(inputs)
	if (locale === "zh") return zh_live_now_badge(inputs)
	if (locale === "es") return es_live_now_badge(inputs)
	if (locale === "pt") return pt_live_now_badge(inputs)
	if (locale === "id") return id_live_now_badge(inputs)
	if (locale === "fr") return fr_live_now_badge(inputs)
	if (locale === "tl") return tl_live_now_badge(inputs)
	if (locale === "vi") return vi_live_now_badge(inputs)
	if (locale === "ko") return ko_live_now_badge(inputs)
	if (locale === "de") return de_live_now_badge(inputs)
	if (locale === "ru") return ru_live_now_badge(inputs)
	if (locale === "tr") return tr_live_now_badge(inputs)
	if (locale === "it") return it_live_now_badge(inputs)
	if (locale === "pl") return pl_live_now_badge(inputs)
	if (locale === "uk") return uk_live_now_badge(inputs)
	if (locale === "hi") return hi_live_now_badge(inputs)
	if (locale === "ar") return ar_live_now_badge(inputs)
	if (locale === "ms") return ms_live_now_badge(inputs)
	if (locale === "bn") return bn_live_now_badge(inputs)
	if (locale === "zh-TW") return zh_tw2_live_now_badge(inputs)
	if (locale === "zh-HK") return zh_hk2_live_now_badge(inputs)
	if (locale === "ur") return ur_live_now_badge(inputs)
	if (locale === "fa") return fa_live_now_badge(inputs)
	if (locale === "sw") return sw_live_now_badge(inputs)
	if (locale === "nl") return nl_live_now_badge(inputs)
	return en_live_now_badge(inputs)
});